import { jsx } from "react/jsx-runtime";
import { NumberInputFieldWUT } from "../../../ui/number-input-field/number-input-field-wut.js";
import { FIELD_TYPES } from "../../../constants/field-types.js";
const DextNumberInputWUT = (props) => {
  const fieldType = FIELD_TYPES.DEXT_NUMBER_INPUT;
  return /* @__PURE__ */ jsx(NumberInputFieldWUT, { ...props, fieldType });
};
export {
  DextNumberInputWUT
};
//# sourceMappingURL=dext-number-input-wut.js.map
